import { render, staticRenderFns } from "./loginmethod.vue?vue&type=template&id=56e5b694&scoped=true"
import script from "./loginmethod.vue?vue&type=script&lang=js"
export * from "./loginmethod.vue?vue&type=script&lang=js"
import style0 from "./loginmethod.vue?vue&type=style&index=0&id=56e5b694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e5b694",
  null
  
)

export default component.exports